<template>
  <div class="arbitration_detail order-info">
    <div class="title-default">
      维权中心 /
      <span>退款仲裁详情</span>
    </div>
    <div class="logistics-info">
      <div class="title-mode">仲裁内容</div>
      <div class="xinxi">
        <div class="tabclass">
          <span class="label">仲裁单号：</span
          >{{ arbitrationData.arbitrationNo }}
        </div>
        <div class="tabclass">
          <span class="label">退款单号：</span>{{ arbitrationData.refundNo }}
        </div>
        <div class="tabclass lan">
          <span class="label">原订单号：</span
          ><a @click="openOrderInfo">{{ arbitrationData.orderNo }}</a>
        </div>
        <div class="tabclass">
          <span class="label">申请时间：</span
          >{{
            new Date(arbitrationData.applyArbitrationTime).format("yyyy-MM-dd")
          }}
        </div>
        <div class="tabclass">
          <span class="label">订单总金额：</span>¥{{
            arbitrationData.totalAmount
          }}
          （含加价 {{ arbitrationData.markupAmount }}元）
        </div>
        <div class="tabclass">
          <span class="label">仲裁退款金额：</span>¥{{
            arbitrationData.applyArbitrationAmount
          }}
        </div>
        <div class="tabclass">
          <span class="label">仲裁内容：</span>
          <div>{{ arbitrationData.complaintDescription }}</div>
        </div>
        <div
          class="tabclass img-info"
          v-if="arbitrationData.arbitrationImgs.length != 0"
        >
          <span class="label">相关图片：</span>
          <!-- <img
            v-for="(item, index) in arbitrationData.arbitrationImgs"
            :key="index"
            :src="item.url"
            alt
          /> -->
          <el-image
            v-for="(item, index) in arbitrationData.arbitrationImgs"
            :key="index"
            :src="item.url"
            :preview-src-list="abnormalImgList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="logistics-info" v-if="arbitrationData.status == 'PROCESSED'">
      <div class="title-mode">仲裁结果</div>
      <div class="xinxi">
        <div class="tabclass">
          <span class="label">处理时间：</span
          >{{ new Date(arbitrationData.handleTime).format("yyyy-MM-dd") }}
        </div>
        <div class="tabclass">
          <span class="label">仲裁结果：</span>
          <div>{{ arbitrationData.arbitrationContent }}</div>
        </div>
      </div>
    </div>
    <div class="logistics-info" v-if="arbitrationData.status == 'PROCESSED'">
      <div class="title-mode">退款信息</div>
      <div class="xinxi">
        <div class="tabclass">
          <span class="label">实际退款金额：</span>¥{{
            arbitrationData.refundAmount
          }}
        </div>
        <div class="tabclass">
          <span class="label">退款时间：</span
          >{{ arbitrationData.refundSuccessTime }}
        </div>
        <div class="tabclass">
          <span class="label">退款方式：</span
          >{{ arbitrationData.payWay || "/" }}
        </div>
        <div class="tabclass">
          <span class="label">退款进度：</span>{{ refundResult }}
        </div>
      </div>
    </div>
    <orderInfo-modal ref="orderInfoModal"></orderInfo-modal>
  </div>
</template>

<script>
import orderInfoModal from "@/components/user/modules/orderInfoModal";

export default {
  data() {
    return {
      arbitrationData: { arbitrationImgs: [] },
      abnormalImgList: [],
    };
  },
  components: {
    orderInfoModal,
  },
  methods: {
    // 跳转订单详情
    openOrderInfo() {
      this.$refs.orderInfoModal.open({id:this.arbitrationData.orderId});
    },
  },
  activated() {
    var _this = this;
    this.$fetch(`/order/api/refund/${_this.$route.query.refundId}`).then(
      (res) => {
        if (res.code == 0) {
          console.log(res);
          this.arbitrationData = res.data;
          res.data.arbitrationImgs.map((i) => {
            this.abnormalImgList.push(i.url);
          });
        } else {
          this.$message(res.message);
        }
      }
    );
  },
  computed: {
    refundResult() {
      let result = "";
      if (this.arbitrationData.status == "WAIT") {
        result = "待处理";
      }
      if (this.arbitrationData.status == "AGREE") {
        result = "同意退款";
      }
      if (this.arbitrationData.status == "REFUSE") {
        result = "拒绝退款";
      }
      if (this.arbitrationData.status == "ARBITRATION") {
        result = "仲裁中";
      }
      if (this.arbitrationData.status == "PROCESSED") {
        result = "仲裁已处理";
      }
      if (this.arbitrationData.status == "SUCCESS") {
        result = "退款成功";
      }
      if (this.arbitrationData.status == "FAIL") {
        result = "退款失败";
      }
      if (this.arbitrationData.status == "CANCEL") {
        result = "取消退款";
      }
      if (this.arbitrationData.status == "ARBITRATION_CANCEL") {
        result = "取消仲裁";
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.arbitration_detail {
  .title-default {
    background: #ffffff;
  }
}
.order-info {
  .xinxi {
    .tabclass {
      height: auto;
    }
    .img-info {
      height: 83px;
      /deep/.el-image {
        width: auto;
        margin-right: 15px;
      }
    }
  }
  .tabclass {
    & > div {
      width: 720px;
      line-height: 20px;
    }
  }
  .title-mode {
    border-bottom: none;
    font-weight: bold;
  }
}
</style>
